<form (ngSubmit)="onSubmit()" [formGroup]="customerSelectionForm">
  <label>
    <input
      #searchTerm
      type="text"
      formControlName="searchTerm"
      placeholder="Customer ID"
      />
    <cx-form-errors
      [control]="customerSelectionForm.get('searchTerm')"
    ></cx-form-errors>
  </label>
  <button type="submit">
    {{ 'asm.customerSearch.submit' | cxTranslate }}
  </button>
</form>

@if (searchResults | async; as results) {
  <div class="asm-results" #resultList>
    @for (result of results.entries; track result) {
      <button
        (click)="selectCustomerFromList(result)"
        >
        <span class="result-name">{{ result.name }}</span>
        <span class="result-id">{{ result.uid }}</span>
      </button>
    }
    @if (
      !(searchResultsLoading$ | async) &&
      searchTerm?.value?.length >= 3 &&
      !!results.entries &&
      results.entries.length <= 0
      ) {
      <button
        (click)="closeResults()"
        >
        {{ 'asm.customerSearch.noMatch' | cxTranslate }}
      </button>
    }
  </div>
}

@if (searchResultsLoading$ | async) {
  <div class="asm-results">
    <div class="spinner" aria-hidden="false" aria-label="Loading">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
